import { Accordion, Image } from "react-bootstrap"
import Label from "./Label"

type CAccordionProps = {
    label?       :string,
    icon?        :string
    children?    :any
    onExpand?    :(expand:boolean) => void
    labelColor? : string
}

const CAccordion:React.FC<CAccordionProps> = ({
    label="Label",children="", onExpand=(expand)=>{}, icon="",labelColor=""}  ) => {
    return (
        <>
        <Accordion>
            <Accordion.Item eventKey="0s">
                <Accordion.Header>
                    {icon && <Image src={icon} width={20}/>}
                    <Label color={labelColor} padding={icon? "0 10px": "0px 10px"}>{label}</Label></Accordion.Header>
                <Accordion.Body onEnter={ (_, isAppearing) => 
                    onExpand(true)
                } onExit={(_) => onExpand(false)}>
                    {children}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        </>
    )
}

export default CAccordion